import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { TakeawayControlsLayout } from 'components';
import { getDeliveryTakeawaySearchQuery } from 'store/ProductDetails/selectors';
import { TAKEAWAY_VIEW_LIST } from 'store/ProductDetails/constants';
import {
  isScreenBelow800,
  isScreenBelow1280,
  isScreenBelow1004,
} from 'store/common/settings/breakpoint/selectors';
import {
  setDeliveryTakeawayView,
  setDeliveryTakeawaySearchQuery,
  setDeliveryTakeawayQueryGTM,
  focusDeliveryTakeawayQueryYM,
} from 'store/ProductDetails/common/actions';

import { SortWidget } from '../../../../widgets';

function TakeawayViewControls({
  tabs,
  searchQuery,
  onTabChange,
  onSearchQueryChange,
  onSearchQueryBlur,
  onSearchQueryFocus,
  isMobile,
  isTablet,
  className,
  noRoute,
  isSmallTablet,
}) {
  return (
    <TakeawayControlsLayout
      {...{
        tabs,
        searchQuery,
        onTabChange,
        onSearchQueryChange,
        onSearchQueryBlur,
        onSearchQueryFocus,
        isMobile,
        isTablet,
        className,
        noRoute,
        isSmallTablet,
      }}
    >
      {({ slug, active }) => (
        <SortWidget isShown={active && slug === TAKEAWAY_VIEW_LIST && !isMobile} />
      )}
    </TakeawayControlsLayout>
  );
}

TakeawayViewControls.propTypes = {
  tabs: PropTypes.arrayOf(
    PropTypes.shape({
      slug: PropTypes.string,
      url: PropTypes.string,
      title: PropTypes.string,
    }),
  ),
  noRoute: PropTypes.bool,
  searchQuery: PropTypes.string,
  onTabChange: PropTypes.func,
  onSearchQueryChange: PropTypes.func,
  onSearchQueryBlur: PropTypes.func,
  isMobile: PropTypes.bool,
  isTablet: PropTypes.bool,
  isSmallTablet: PropTypes.bool,
  className: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
};

const mapStateToProps = (state) => ({
  searchQuery: getDeliveryTakeawaySearchQuery(state),
  isMobile: isScreenBelow800(state),
  isTablet: isScreenBelow1280(state),
  isSmallTablet: isScreenBelow1004(state),
});

const mapDispatchToProps = {
  onTabChange: setDeliveryTakeawayView,
  onSearchQueryChange: setDeliveryTakeawaySearchQuery,
  onSearchQueryBlur: setDeliveryTakeawayQueryGTM,
  onSearchQueryFocus: focusDeliveryTakeawayQueryYM,
};

export default connect(mapStateToProps, mapDispatchToProps)(TakeawayViewControls);
